import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchDetailsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { isPhoneNative } from '@helpers';

const BatchDetailsStack = createStackNavigator();

const BatchDetailsNavigator = () => {
  return (
    <BatchDetailsStack.Navigator
      screenOptions={{
        ...NAVIGATION_CONFIG,
        presentation: isPhoneNative ? 'modal' : 'transparentModal',
        gestureEnabled: false,
        animationEnabled: false,
        cardStyle: { backgroundColor: 'transparent', display: 'flex' },
        detachPreviousScreen: false,
      }}
    >
      {batchDetailsConfig.map(({ Component, name }) => (
        <BatchDetailsStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchDetailsStack.Navigator>
  );
};

export { BatchDetailsNavigator };
